import { Controller } from "@hotwired/stimulus"

// Kopiowanie tekstu do schowka.
// Źródło tekstu: domyślnie `data-redirect-url` na elemencie kontrolera (krótkie wartości, np. link),
// a gdy podany jest target `source` - jego zawartość (pole textarea/input albo dowolny element),
// co pozwala kopiować treści wielolinijkowe, których nie ma sensu trzymać w atrybucie.
export default class extends Controller {
  static targets = ["button", "tooltip", "source"]

  connect() {
    if (!this.buttonTarget.dataset.action) this.buttonTarget.dataset.action = ""
    this.buttonTarget.dataset.action += " click->copy-to-clipboard#copy"
    // this.buttonTarget.dataset.action += " mouseover->copy-to-clipboard#showTooltip"
    this.buttonTarget.dataset.action += " mouseout->copy-to-clipboard#hideTooltip"

    this.buttonTarget.classList.add("cursor-pointer")
    this.initMessage = this.tooltipTarget.dataset.initMessage
  }

  copy(e) {
    const text = this.textToCopy()

    // Spróbuj użyć nowoczesnego API
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(() => {
        this.showCopiedMessage(e)
      }).catch((err) => {
        console.error("Failed to copy using clipboard API:", err)
        this.fallbackCopy(text, e)
      })
    } else {
      // Fallback dla starszych przeglądarek lub HTTP
      console.log("fallbackCopy:", text)
      this.fallbackCopy(text, e)
    }
  }

  // tekst do skopiowania - z targetu `source` (pole formularza albo zwykły element), a bez niego
  // z atrybutu `data-redirect-url`
  textToCopy() {
    if (!this.hasSourceTarget) return this.element.dataset.redirectUrl

    const source = this.sourceTarget
    if (source.value !== undefined) return source.value
    return source.textContent
  }

  fallbackCopy(text, e) {
    // Użyj starszej metody z textarea
    const textarea = document.createElement("textarea")
    textarea.value = text
    textarea.style.position = "fixed"
    textarea.style.opacity = "0"
    document.body.appendChild(textarea)
    textarea.select()

    try {
      const successful = document.execCommand("copy")
      if (successful) {
        this.showCopiedMessage(e)
      } else {
        console.error("Failed to copy using execCommand")
      }
    } catch (err) {
      console.error("Failed to copy:", err)
    } finally {
      document.body.removeChild(textarea)
    }
  }

  showCopiedMessage(e) {
    this.showTooltip(e)
    this.tooltipTarget.innerText = this.tooltipTarget.dataset.copiedMessage
    setTimeout(() => {
      this.hideTooltip(e)
      this.tooltipTarget.innerText = this.initMessage
    }, 1500)
  }

  showTooltip(_e) {
    this.tooltipTarget.classList.remove("hidden")
  }

  hideTooltip(_e) {
    this.tooltipTarget.classList.add("hidden")
  }
}
